function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.96442661,11.840058 C8.76011099,11.840058 9.458451,11.6622987 10.0594466,11.3067801 C10.6604423,10.9512616 10.9609401,10.3604236 10.9609401,9.53426615 C10.9609401,8.87063149 10.7239278,8.36444077 10.249903,8.01569399 C9.97564585,7.81592641 9.58626839,7.65848247 9.08177063,7.54336218 L8.03553032,7.30465685 C7.331265,7.14213408 6.87924856,7.00669843 6.67948099,6.89834992 C6.3747508,6.72905536 6.22238571,6.46156997 6.22238571,6.09589373 C6.22238571,5.7640764 6.35274251,5.47288976 6.61345612,5.22233382 C6.87416972,4.97177788 7.30248493,4.84649991 7.89840174,4.84649991 C8.63652597,4.84649991 9.15964612,5.04118865 9.4677622,5.43056612 C9.63367086,5.64387726 9.74201937,5.95030041 9.79280774,6.34983556 L10.7425502,6.34983556 C10.7425502,5.52029224 10.4691395,4.91675715 9.92231806,4.53923029 C9.37549667,4.16170343 8.71101557,3.97294 7.92887476,3.97294 C7.07901612,3.97294 6.42215328,4.18794409 5.95828621,4.61795226 C5.49441915,5.04796043 5.26248562,5.59816773 5.26248562,6.26857417 C5.26248562,6.88819225 5.49949799,7.35375227 5.97352272,7.66525426 C6.24777989,7.84470648 6.71503285,8.0089222 7.37528158,8.15790141 L8.38597004,8.38644906 C8.93448437,8.51172703 9.3374054,8.6590133 9.59473311,8.82830785 C9.84867494,9.0009883 9.97564585,9.29048199 9.97564585,9.69678892 C9.97564585,10.2385315 9.67430155,10.6143654 9.07161296,10.8242907 C8.76011099,10.9326392 8.41475011,10.9868134 8.03553032,10.9868134 C7.18905758,10.9868134 6.59821961,10.7396434 6.2630164,10.2453033 C6.08695007,9.98120377 5.98706629,9.63753583 5.96336505,9.21429944 L5.01362263,9.21429944 C5.00346496,10.0201415 5.26079267,10.658382 5.78560577,11.1290209 C6.31041887,11.6030456 7.03669249,11.840058 7.96442661,11.840058 Z",
  stroke: "currentColor",
  strokeWidth: 0.25,
  fill: "currentColor",
  strokeLinejoin: "round"
});
var _ref3 = /*#__PURE__*/React.createElement("line", {
  x1: 7.987,
  y1: 12.693,
  x2: 7.987,
  y2: 3.093,
  stroke: "currentColor",
  strokeLinecap: "round"
});
var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 8,
  r: 7.5,
  stroke: "currentColor"
});
function SvgBalance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Balance status") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalance);
export default __webpack_public_path__ + "static/media/balance.3b4deae2b55d73505e46333c66763ec0.svg";
export { ForwardRef as ReactComponent };